import React from "react"
import { H2 } from "../headings/index"
import { CoberturasWrapper, CoberturasContainer } from "./style"
import CasaCoberturasSrc from "../../images/casa-coberturas.png"
import PictoRaio from "../../images/raio.svg"
import PictoFogo from "../../images/fire.svg"
import PictoExplosao from "../../images/explosao-tchacabum.svg"
import PictoPerdaDeAluguel from "../../images/perda-de-aluguel.png"
import PictoDanosEletricos from "../../images/danos-eletricos.png"
import PictoResponsabilidadeCivil from "../../images/responsabilidade-civil.png"
import PictoVendaval from "../../images/vendaval.png"

const Coberturas = () => {
  return (
    <CoberturasWrapper>
      <H2>Conheça Nossas Coberturas</H2>
      <p>
        Seguro essencial para imóveis alugados. Seguro, prático e cabe no seu
        bolso.
      </p>

      <CoberturasContainer>
        <div className="left">
          <img src={CasaCoberturasSrc} width="280" />
          <p>
            Com o Seguro Residencial CredPago, você fica protegido o tempo todo
            contra os danos provocados por:
          </p>
          <a href="/seguro/docs/Condicoes_Gerais_Apolice.pdf" target="_blank">
            Ver Condições Gerais
          </a>
        </div>
        <div className="right">
          <div className="coberturas">
            <strong>Coberturas inclusas</strong>
            <div className="items col-3">
              <div className="item">
                <div className="item-content">
                  <img src={PictoFogo} width="49" height="49" alt="Incêndio" />
                  <span>Incêndio</span>
                </div>
              </div>
              <div className="item">
                <div className="item-content">
                  <img src={PictoRaio} width="49" height="49" alt="Raio" />
                  <span>Raio</span>
                </div>
              </div>
              <div className="item">
                <div className="item-content">
                  <img
                    src={PictoExplosao}
                    width="49"
                    height="49"
                    alt="Explosão"
                  />
                  <span>Explosão</span>
                </div>
              </div>
            </div>
          </div>
          <div className="coberturas">
            <strong>Coberturas opcionais</strong>
            <div className="items">
              <div className="item">
                <div className="item-content">
                  <img
                    src={PictoPerdaDeAluguel}
                    width="49"
                    height="49"
                    alt="Perda de Aluguel"
                  />
                  <span>
                    Perda <br /> de Aluguel
                  </span>
                </div>
              </div>
              <div className="item">
                <div className="item-content">
                  <img
                    src={PictoDanosEletricos}
                    width="49"
                    height="49"
                    alt="Danos elétricos"
                  />
                  <span>
                    Danos <br /> elétricos
                  </span>
                </div>
              </div>
              <div className="item">
                <div className="item-content">
                  <img
                    src={PictoResponsabilidadeCivil}
                    width="49"
                    height="49"
                    alt="Responsabilidade Civil"
                  />
                  <span>Responsabilidade Civil</span>
                </div>
              </div>
              <div className="item">
                <div className="item-content">
                  <img
                    src={PictoVendaval}
                    width="49"
                    height="49"
                    alt="Vendaval"
                  />
                  <span>Vendaval</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </CoberturasContainer>
    </CoberturasWrapper>
  )
}
export default Coberturas
